/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconPhoneTalk extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "PhoneTalkIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><g><rect width="64" height="64" fill="none"></rect><path d="M11.43,50.58A4,4,0,0,1,10.52,48a2.8,2.8,0,0,1,1-2.12c.71-.56,8.44-6.37,9.39-7a3.86,3.86,0,0,1,3.77,0c.81.37,3.3,1.6,4.46,2.18A57.46,57.46,0,0,0,36,34.31a57.45,57.45,0,0,0,5.9-7.57c-.71-1.09-2.22-3.42-2.68-4.18a3.85,3.85,0,0,1-.46-3.77c.53-.95,5.38-9.32,5.9-10.13a3.38,3.38,0,0,1,4.66-.6c.08,0,7.39,4.73,7.46,7.59.22,8.17-7.17,18.23-13.4,25.23S28,56.38,19.8,57.12h-.05C16.91,57.29,11.48,50.64,11.43,50.58Z" fill="#4b5b63"></path><path d="M20.29,21.59a1.36,1.36,0,0,1-1-.38L13.4,15.46a1.37,1.37,0,0,1,1.9-2l5.94,5.75a1.37,1.37,0,0,1-1,2.35Z" fill="#a4b6bf"></path><path d="M8.61,31a1.37,1.37,0,0,1,0-2.73l8.26-.14h0a1.37,1.37,0,0,1,0,2.73L8.64,31Z" fill="#a4b6bf"></path><path d="M29.45,17.87a1.37,1.37,0,0,1-1.37-1.34l-.14-8.26a1.37,1.37,0,0,1,1.34-1.39h0a1.37,1.37,0,0,1,1.37,1.34l.14,8.26a1.37,1.37,0,0,1-1.34,1.39Z" fill="#a4b6bf"></path></g></svg>
    `;
}
